import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import moment from "moment";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import Companies from "../pages/Companies/";
import Wallets from "../pages/Wallets/";
import QuickMessages from "../pages/QuickMessages/";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import PushNotificationPrompt from "../components/PushNotificationPrompt";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections/";
import Reports from "../pages/Reports";
import RelatorioVendas from "../pages/RelatorioVendas";
import Subscription from "../pages/Subscription/";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files/";
import ToDoList from "../pages/ToDoList/";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import BirthdaySettingsPage from "../pages/BirthdaySettings";
import CallHistoricals from "../pages/CallHistoricals";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import OfficialCampaigns from "../pages/OfficialCampaigns";
import OfficialCampaignReport from "../pages/OfficialCampaignReport";
import CampaignsPro from "../pages/CampaignsPro";
import CampaignProReport from "../pages/CampaignProReport";
import ContactListProItems from "../pages/ContactListProItems";
import Floup from "../pages/Floup";
import FloupDashboard from "../pages/FloupDashboard";
import StatusPage from "../pages/Status";
import SuperAdmin from "../pages/SuperAdmin";
import ResgateComercial from "../pages/ResgateComercial";
import AgendaMedica from "../pages/AgendaMedica";
import ConfigAgenda from "../pages/ConfigAgenda";
import RelatoriosDiarios from "../pages/RelatoriosDiarios";
import Prontuario from "../pages/Prontuario";
import CadastrosPendentes from "../pages/CadastrosPendentes"; // Cadastro paciente + aprovação (LGPD) / S86
import FinanceiroClinica from "../pages/FinanceiroClinica";
import Quadros from "../pages/Quadros";
import Estoque from "../pages/Estoque";
import GestaoClinica from "../pages/GestaoClinica"; // Dashboard Gestão (D1 / S88)
import NoShows from "../pages/NoShows"; // Faltosos / No-Show (S112)
import Convenios from "../pages/Convenios"; // Convênios / Controle de Glosa (S120)
import PatientNew from "../pages/Prontuario/PatientNew";
import PatientDetail from "../pages/Prontuario/PatientDetail";
import EncounterPage from "../pages/Prontuario/EncounterPage";
import Teleconsultas from "../pages/Teleconsultas"; // Telemedicina Fase 1 / S101
import TeleconsultaRoom from "../pages/Teleconsulta"; // Telemedicina Fase 1 / S101 (sala do médico)
import Contratos from "../pages/Contratos"; // Assinatura de contratos (e-sign) / S104
import Receituario from "../pages/Prontuario/Receituario";

const RoutesContent = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  // Verificar se a empresa está vencida
  const isCompanyExpired = () => {
    if (!user || !user.company || user.company.id === 1) {
      return false; // Empresa ID 1 nunca expira
    }

    const dueDate = user.company.dueDate;
    if (!dueDate) return false;

    // Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
    const hojeInicio = moment().startOf('day');
    const vencimentoInicio = moment(dueDate).startOf('day');
    
    // Empresa está vencida apenas após o dia do vencimento
    return hojeInicio.isAfter(vencimentoInicio, 'day');
  };

  return (
    <TicketsContextProvider>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} />
        <WhatsAppsProvider>
          <LoggedInLayout hideMenu={isCompanyExpired()}>
                <Route
                  exact
                  path="/financeiro"
                  component={Financeiro}
                  isPrivate
                />

                <Route
                  exact
                  path="/financeiro-aberto"
                  component={Financeiro}
                  isPrivate
                />

                <Route
                  exact
                  path="/companies"
                  component={Companies}
                  isPrivate
                />
                <Route
                  exact
                  path="/super-admin"
                  component={SuperAdmin}
                  isPrivate
                />
                <Route
                  exact
                  path="/birthday-settings"
                  component={BirthdaySettingsPage}
                  isPrivate
                />
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/call-historicals" component={CallHistoricals} isPrivate />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  component={TicketResponsiveContainer}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                <Route
                  exact
                  path="/quick-messages"
                  component={QuickMessages}
                  isPrivate
                />
                <Route
                  exact
                  path="/status"
                  component={StatusPage}
                  isPrivate
                />
                <Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route
                  exact
                  path="/schedules"
                  component={Schedules}
                  isPrivate
                />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route
                  exact
                  path="/contacts/import"
                  component={ContactImportPage}
                  isPrivate
                />
                <Route exact path="/wallets" component={Wallets} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route
                  exact
                  path="/messages-api"
                  component={MessagesAPI}
                  isPrivate
                />
                <Route
                  exact
                  path="/settings"
                  component={Settings}
                  isPrivate
                />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route exact path="/reports" component={Reports} isPrivate />
                <Route
                  exact
                  path="/relatorio-vendas"
                  component={RelatorioVendas}
                  isPrivate
                />
                <Route
                  exact
                  path="/queue-integration"
                  component={QueueIntegration}
                  isPrivate
                />
                <Route
                  exact
                  path="/announcements"
                  component={Annoucements}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route
                  exact
                  path="/moments"
                  component={ChatMoments}
                  isPrivate
                />
                <Route exact path="/Kanban" component={Kanban} isPrivate />
                <Route
                  exact
                  path="/TagsKanban"
                  component={TagsKanban}
                  isPrivate
                />
                <Route
                  exact
                  path="/resgate-comercial"
                  component={ResgateComercial}
                  isPrivate
                />
                <Route
                  exact
                  path="/agenda-medica"
                  component={AgendaMedica}
                  isPrivate
                />
                <Route
                  exact
                  path="/configuracoes-agenda"
                  component={ConfigAgenda}
                  isPrivate
                />
                <Route
                  exact
                  path="/relatorios-diarios"
                  component={RelatoriosDiarios}
                  isPrivate
                />
                <Route
                  exact
                  path="/prontuario"
                  component={Prontuario}
                  isPrivate
                />
                {/* Telemedicina Fase 1 / S101 — rotas sempre montadas; o menu é gated
                    por telemedicina_enabled e o backend responde 403 se o tenant não tem. */}
                <Route exact path="/teleconsultas" component={Teleconsultas} isPrivate />
                <Route exact path="/teleconsulta/:sessionId" component={TeleconsultaRoom} isPrivate />
                {/* Contratos (e-sign / S104) — menu gated por esign_enabled; backend 403 se off. */}
                <Route exact path="/contratos" component={Contratos} isPrivate />
                {/* [S89 RBAC] /financas /estoque /gestao-clinica gateadas por FLAG de
                    acesso (papéis). Funcionário sem a flag → rota não renderiza (fallback). */}
                {(user.super || user.profile === "admin" || user.accessFinanceiro === "enabled") && (
                  <Route
                    exact
                    path="/financas"
                    component={FinanceiroClinica}
                    isPrivate
                  />
                )}
                <Route exact path="/quadros" component={Quadros} isPrivate />
                <Route exact path="/quadros/:boardId" component={Quadros} isPrivate />
                {(user.super || user.profile === "admin" || user.accessEstoque === "enabled") && (
                  <Route exact path="/estoque" component={Estoque} isPrivate />
                )}
                {(user.super || user.profile === "admin" || user.accessClinicDashboard === "enabled") && (
                  <Route exact path="/gestao-clinica" component={GestaoClinica} isPrivate />
                )}
                {/* [S112] Faltosos — recepção recupera. isPrivate (sem gate admin). */}
                <Route exact path="/faltosos" component={NoShows} isPrivate />
                {/* [S120] Convênios — controle de glosa. isPrivate; gate real por flag. */}
                <Route exact path="/convenios" component={Convenios} isPrivate />
                <Route
                  exact
                  path="/prontuario/receituario"
                  component={Receituario}
                  isPrivate
                />
                <Route
                  exact
                  path="/prontuario/novo"
                  component={PatientNew}
                  isPrivate
                />
                <Route
                  exact
                  path="/prontuario/paciente/:id"
                  component={PatientDetail}
                  isPrivate
                />
                <Route
                  exact
                  path="/prontuario/paciente/:patientId/consulta/nova"
                  component={EncounterPage}
                  isPrivate
                />
                <Route
                  exact
                  path="/prontuario/consulta/:id"
                  component={EncounterPage}
                  isPrivate
                />
                <Route
                  exact
                  path="/cadastros-pendentes"
                  component={CadastrosPendentes}
                  isPrivate
                />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route
                  exact
                  path="/allConnections"
                  component={AllConnections}
                  isPrivate
                />

                <Route
                  exact
                  path="/plugins/floup"
                  component={Floup}
                  isPrivate
                />
                <Route
                  exact
                  path="/plugins/floup/dashboard"
                  component={FloupDashboard}
                  isPrivate
                />

                <Route
                  exact
                  path="/phrase-lists"
                  component={CampaignsPhrase}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilders"
                  component={FlowBuilder}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                />

                {showCampaigns && (
                  <>
                    <Route
                      exact
                      path="/contact-lists"
                      component={ContactLists}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/contact-lists/:contactListId/contacts"
                      component={ContactListItems}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns"
                      component={Campaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/official-campaigns"
                      component={OfficialCampaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign/:campaignId/report"
                      component={CampaignReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/official-campaigns/:id/report"
                      component={OfficialCampaignReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns-config"
                      component={CampaignsConfig}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns-pro"
                      component={CampaignsPro}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns-pro/:campaignId/report"
                      component={CampaignProReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns-pro/lists/:contactListProId"
                      component={ContactListProItems}
                      isPrivate
                    />
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer position="top-center" autoClose={3000} />
        </TicketsContextProvider>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PushNotificationPrompt />
        <RoutesContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
